import { css } from 'styled-components';
import colors from '../../style/colors';
import { actionColorDark } from './../../style/theme-helpers';

const variants = {
  gray900: css`
    color: ${colors.gray900};
  `,
  inherit: css`
    color: inherit;
  `,
  gray800: css`
    color: ${colors.gray800};
  `,
  gray600: css`
    color: ${colors.gray600};
  `,
  gray400: css`
    color: ${colors.gray400};
  `,
  gray300: css`
    color: ${colors.gray300};
  `,
  action: css`
    color: ${props => props.theme.actionColor};
  `,
  'action-dark': css`
    color: ${actionColorDark};
  `,
  negative: css`
    color: ${colors.negative};
  `,
  attention: css`
    color: ${colors.attention};
  `,
  transparent: css`
    color: ${colors.transparent};
  `,
  emerald: css`
    color: ${colors.emerald};
  `,
  highlight: css`
    color: ${colors.highlight};
  `,
  white: css`
    color: ${colors.white};
  `,
  linkedin: css`
    color: ${colors.linkedin};
  `,
  sun: css`
    color: ${colors.sun};
  `,
  'negative-dark': css`
    color: ${colors.negativeDark};
  `,
  positive: css`
    color: ${colors.positive};
  `,
  'positive-dark': css`
    color: ${colors.positiveDark};
  `,
  coral: css`
    color: ${colors.coral};
  `,
  pumpkin: css`
    color: ${colors.pumpkin};
  `,
  darkPumpkin: css`
    color: ${colors.darkPumpkin};
  `,
  teal: css`
    color: ${colors.teal};
  `,
  lavender: css`
    color: ${colors.lavender};
  `,
  'lavender-dark': css`
    color: ${colors.darkLavender};
  `,
  violet: css`
    color: ${colors.violet};
  `,
  darkViolet: css`
    color: ${colors.darkViolet};
  `,
  'dark-blue': css`
    color: ${colors.darkBlue};
  `,
  amberGlow: css`
    color: ${colors.amberGlow};
  `,
};

const sizes = {
  xxs: '8px',
  xs: '10px',
  sm: '12px',
  md: '14px',
  lg: '16px',
  xl: '20px',
  xxl: '24px',
  '2xxl': '32px',
  '3xxl': '40px',
  '4xxl': '50px',
};

export { sizes, variants };
